module.exports = __webpack_public_path__ + "static/media/qr-code-email.ecf03167.svg";